/* AIVIQ blog index (sections/aiviq-blog.liquid): the topic chips and the machine tiles filter the cards on the page.
   Written by hand in build/blog/mkblogtheme.pl. Without the script every article is simply shown. */
(function () {
  const root = document.querySelector('[data-abg]');
  if (!root || root.dataset.abgReady) return;
  root.dataset.abgReady = '1';
  const chips = [...root.querySelectorAll('[data-abg-topic]')];
  const machines = [...root.querySelectorAll('[data-abg-machine]')];
  const cards = [...root.querySelectorAll('[data-abg-grid] [data-abg-card]')];
  const feat = root.querySelector('[data-abg-feat]');
  const none = root.querySelector('[data-abg-none]');
  if (!chips.length && !machines.length) return;
  let topic = '';
  let machine = '';
  const apply = () => {
    let shown = 0;
    cards.forEach((c) => {
      const ok = (!topic || c.dataset.topic === topic) && (!machine || c.dataset.machine === machine);
      c.hidden = !ok;
      if (ok) shown++;
    });
    if (feat) {
      const f = feat.querySelector('[data-abg-card]');
      const ok = !f || ((!topic || f.dataset.topic === topic) && (!machine || f.dataset.machine === machine));
      feat.hidden = !ok;
      if (ok && f) shown++;
    }
    if (none) none.hidden = shown > 0;
    chips.forEach((b) => { const on = b.dataset.abgTopic === topic; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    machines.forEach((b) => { const on = b.dataset.abgMachine === machine; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  };
  chips.forEach((b) => b.addEventListener('click', () => { topic = b.dataset.abgTopic; apply(); }));
  machines.forEach((b) => b.addEventListener('click', () => {
    machine = machine === b.dataset.abgMachine ? '' : b.dataset.abgMachine;
    apply();
    const grid = root.querySelector('[data-abg-grid]');
    if (machine && grid) grid.closest('section').scrollIntoView({ behavior: 'smooth', block: 'start' });
  }));
})();
